<template>
  <div class="custom-province"  @click.stop>
    <div class="cp-input" @click="focus">
      <el-input class="el-select el-select--small" :placeholder="placeholder" :value="valueInput" :name="name" readonly clearable :disabled="disabled">
        <i slot="suffix" v-if="!clearable" class="el-input__icon el-icon-arrow-down" :class="isShow ? 'el-select__caret' : ''"></i>
        <i v-show="!disabled && valueInput" slot="suffix" @click="clearInput" class="el-icon-circle-close"></i>
      </el-input>
    </div>
    <div class="cp-modal" v-show="isShow">
      <div class="cpm-ul">
        <div
          ref="pList"
          v-for="(item, index) in initData"
          :key="index"
          @click="clickTab(index)"
          class="cpml-li"
          :class="[item.isActive ? 'isActive' : '', item.disable ? 'disable' : '']"
        >
          {{ item.name }}
        </div>
        <!-- <div ref="city"
             @click="clickCity"
             class="cpml-li">{{$lang('市')}}</div>
        <div ref="area"
             @click="clickArea"
             class="cpml-li">{{$lang('区')}}</div> -->
        <div class="cpml-line" :style="'width:' + lineWidth + 'px;' + 'transform:translateX(' + lineLeftW + 'px)'"></div>
      </div>
      <div class="cpm-content">
        <el-scrollbar>
          <template v-if="type === 0">
            <div class="cpmc-li" ref="cmpcli" v-for="item in provinceList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
          <template v-if="type === 1">
            <div class="cpmc-li" ref="cmpcli" v-for="item in cityList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
          <template v-if="type === 2">
            <div class="cpmc-li" ref="cmpcli" v-for="item in areaList" @click="selectListClick(item.id)" :class="item.isSelectActive ? 'isSelectActive' : ''" :key="item.id">
              {{ item.nativeName }}
            </div>
          </template>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
// import { setTimeout } from 'timers'
// import { RESPONSE_SUCCESS } from '@constants/index'
import { RESPONSE_SUCCESS } from "@/constants"
import debounce from 'lodash/debounce'
// import * as Api from '@api/base/public'
// import fetch from '../../http/request'

// const reqSysArea = (params = {}) => {
//   params.size = params.size || 5000
//   return fetch.get('/lmdm/sysArea/select', { params })
// }
export default {
  name: 'BaseSelectMore',
  // directives: { clickoutside },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    initAddressData: {
      type: Object,
      default: function() {
        return {
          formProps: {
            provinceIdProp: 'provinceId',
            provinceNameProp: 'provinceName',
            cityIdProp: 'cityId',
            cityNameProp: 'cityName',
            areaIdProp: 'areaId',
            areaNameProp: 'areaName',
          },
          defaultData: {},
        }
      },
    },
    /* eslint-disable */
    value: ''
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.isShow = false
      }
    },
    'value'(val) {
      const {  provinceNameProp, cityNameProp, areaNameProp } = this.initAddressData.formProps
      if(val){
          if(val[areaNameProp]){
              this.valueInput = `${val[provinceNameProp]}/${val[cityNameProp]}/${val[areaNameProp]}`
          }else if(val[cityNameProp]){
              this.valueInput = `${val[provinceNameProp]}/${val[cityNameProp]}`
          }else if(val[provinceNameProp]){
              this.valueInput = `${val[provinceNameProp]}`
          }else {
                this.valueInput = ''
            }
      }
    },
    'initAddressData.defaultData': {
      handler(val) {
        const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
        const data = {}
        data.provinceId = val[provinceIdProp]
        data.provinceName = val[provinceNameProp]
        data.cityId = val[cityIdProp]
        data.cityName = val[cityNameProp]
        data.areaId = val[areaIdProp]
        data.areaName = val[areaNameProp]
        this.addressInfo = data
        // this.initParams()
        this.getProList()
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      isShow: false,
      placeholder: '请选择省市区',
      activeName: 'first',
      lineWidth: 0,
      lineLeftW: 10,
      initData: [
        {
          name: '省份',
          isActive: true,
          disable: false
        },
        {
          name: '城市',
          isActive: false,
          disable: true
        },
        {
          name:'区县',
          isActive: false,
          disable: true
        }
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      type: 0,
      addressInfo: {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: ''
      },
      name: '',
      valueInput: '',

      clearable: false,
      suffixIcon: 'el-icon-arrow-down'
    }
  },
  created() {
  },
  methods: {
    hideModal() {
      this.isShow = false
    },
    focus() {
      if (this.disabled) {
        return
      }
      this.isShow = !this.isShow
      const isAreaId = this.addressInfo.areaId
      if (isAreaId) {
        this.initData.map(item => (item.disable = false))
        setTimeout(() => {
          this.clickTab(2)
        }, 10)
      }
    },
    // 点击tab
    clickTab(index) {
      if (index === 0) {
        if (this.initData[0].disable) return
        // 省
        const { clientWidth } = this.$refs.pList[0]
        this.lineLeftW = 10
        setTimeout(() => {
          this.lineWidth = clientWidth
        }, 200)
        this.selectList = this.provinceList
        this.type = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else if (index === 1) {
        if (this.initData[1].disable) return
        // 市
        const { clientWidth } = this.$refs.pList[1]
        this.lineLeftW = this.$refs.pList[1].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.cityList
        this.type = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      } else {
        if (this.initData[2].disable) return
        // 区
        const { clientWidth } = this.$refs.pList[2]
        this.lineLeftW = this.$refs.pList[2].getBoundingClientRect().x - this.$refs.pList[0].getBoundingClientRect().x + 10
        this.lineWidth = clientWidth
        this.selectList = this.areaList
        this.type = index
        this.initData.map(item => (item.isActive = false))
        this.initData[index].isActive = true
      }
       this.updataValue(this.addressInfo)
    },
    // 获取省数据
    async getProList() {
           let params = {
              parentId:"1",
              type:"2"
          }
        const formData = new FormData()
          Object.keys(params).forEach((key) => {
                formData.append(key, params[key])
        })
        
        this.cityList = [];
        this.areaList = [];
        this.initData[1].disable = true;
        this.initData[2].disable = true;
      const { data, code, msg } = await this.$API.areaList(formData)
    if (code === RESPONSE_SUCCESS) {
        const records = data
        records.map(item => (item.isSelectActive = false))
        this.provinceList = records
        const isAreaId = this.addressInfo.areaId
        if(isAreaId){
          const { provinceId } = this.addressInfo
          const obj = this.provinceList.find(item => item.id === provinceId)
          if (obj) obj.isSelectActive = true
          this.clearable = true
          this.getCityList(provinceId)
        } else {
          this.clearInput()
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取市区数据
    async getCityList(parentId) {
          let params = {
              parentId:parentId,
              type:"3"
          }
        const formData = new FormData()
          Object.keys(params).forEach((key) => {
                formData.append(key, params[key])
        })
        this.areaList = [];
        this.initData[2].disable = true;
      const { data, code, msg } = await this.$API.areaList(formData)
      if (code === RESPONSE_SUCCESS) {
        const records = data
        records.map(item => (item.isSelectActive = false))
        this.cityList = records
        const isAreaId = this.addressInfo.areaId
        if(isAreaId){
          const { cityId } = this.addressInfo
          const obj = this.cityList.find(item => item.id === cityId)
          if (obj) obj.isSelectActive = true
          this.getAreaList(cityId)
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 获取区县数据
    async getAreaList(parentId) {
            let params = {
              parentId:parentId,
              type:"4"
          }
        const formData = new FormData()
          Object.keys(params).forEach((key) => {
                formData.append(key, params[key])
        })
      // const { data, code, msg } = await this.$selectApi.reqSysArea({ parentId })
    const { data, code, msg } = await this.$API.areaList(formData)
      if (code === RESPONSE_SUCCESS) {
        const records = data
        records.map(item => (item.isSelectActive = false))
        this.areaList = records
        const isAreaId = this.addressInfo.areaId
        if(isAreaId){
          const { areaId, provinceName, cityName, areaName } = this.addressInfo
          const obj = this.areaList.find(item => item.id === areaId)
          if (obj) obj.isSelectActive = true
          // this.valueInput = `${provinceName} / ${cityName} / ${areaName}`
          this.updataValue(this.addressInfo)
        }
      } else {
        this.$message.error(msg)
      }
    },
    // 选中
    selectListClick(id) {
      if (this.type === 0) {
        this.getCityList(id)
        this.provinceList.map(item => (item.isSelectActive = false))
        const obj = this.provinceList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.provinceId = obj.id
          this.addressInfo.provinceName = obj.nativeName
          this.addressInfo.cityId = ''
          this.addressInfo.cityName = ''
          this.addressInfo.areaId = ''
          this.addressInfo.areaName = ''
          this.initData[1].disable = false
        }
        this.clickTab(1)
      } else if (this.type === 1) {
        this.getAreaList(id)
        this.cityList.map(item => (item.isSelectActive = false))
        const obj = this.cityList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.cityId = obj.id
          this.addressInfo.cityName = obj.nativeName
          this.addressInfo.areaId = ''
          this.addressInfo.areaName = ''
          this.initData[2].disable = false
        }
        this.clickTab(2)
      } else {
        this.areaList.map(item => (item.isSelectActive = false))
        const obj = this.areaList.find(item => item.id === id)
        if (obj) {
          obj.isSelectActive = true
          this.addressInfo.areaId = obj.id
          this.addressInfo.areaName = obj.nativeName
          const { areaName, cityName, provinceName } = this.addressInfo
          // this.valueInput = `${provinceName} / ${cityName} / ${areaName}`
          this.isShow = false
          this.clearable = true
          this.clickTab(0)
          this.updataValue(this.addressInfo)
        }
      }
    },
    // 传递选中的值到父组件
    updataValue:debounce( async function(addressInfo) {
      const data = await this.getAddrData(addressInfo)
      this.$emit('input', data)
      this.$emit('change', data)
      this.$emit('changeValue', data)
      },100)
    ,
    getAddrData(addressInfo) {
      const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
      const data = {}
      data[provinceIdProp] = addressInfo.provinceId
      data[provinceNameProp] = addressInfo.provinceName
      data[cityIdProp] = addressInfo.cityId
      data[cityNameProp] = addressInfo.cityName
      data[areaIdProp] = addressInfo.areaId
      data[areaNameProp] = addressInfo.areaName
      return data
    },
    // 清空选中
    clearInput() {
      const { clientWidth } = this.$refs.pList[0]
      this.lineWidth = clientWidth
      this.valueInput = ''
      this.initData.map(item => {
        item.disable = true
        item.isActive = false  
      })
      this.initData[0].disable = false
      this.initData[0].isActive = true
      this.$emit('input', '')
      this.$emit('change', '')
      this.$emit('changeValue','')
      this.type = 0
      this.addressInfo = {
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$selectH: 360px;
.custom-province {
  position: relative;
  display: inline-block;
  .el-select__caret {
    transform: rotateZ(180deg);
    transition: transform 0.3s;
    cursor: pointer;
  }
  .el-icon-circle-close {
    line-height: 32px;
  }
  span,
  .el-input__suffix {
    cursor: pointer;
  }
  .el-scrollbar__wrap {
    overflow: auto;
    // max-height: $selectH;
    height: $selectH;
    min-width: 200px;
      margin-bottom:0 !important;
  }
  div {
    box-sizing: border-box;
  }
  .disable {
    opacity: 0.5;
    cursor: not-allowed !important;
  }
  .cp-modal {
    position: absolute;
    background: #ffffff;
    width: 100%;
    // height: $selectH;
    height: 300px;
    overflow-y: auto;
    z-index: 9999;
    top: 37px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #dddddd;
    .cpm-ul {
      display: flex;
      height: 28px;
      align-items: center;
      border-bottom: 1px solid #dddddd;
      padding: 0 10px;
      position: relative;
      .isActive {
        font-weight: bolder;
        color:$theme-color !important;
      }
      .cpml-line {
        width: 50px;
        height: 2px;
        transform: rotateZ(180deg);
        transition: transform 0.3s;
        position: absolute;
        bottom: -1px;
        left: 0;
      }
      .cpml-li {
        cursor: pointer;
        margin-left: 20px;
        color: #999999;
        font-size: 14px;
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .cpm-content {
      padding-top: 5px;
      .cpmc-li {
        width: 100%;
        padding-left: 20px;
        color: #999999;
        font-size: 12px;
        height: 32px;
        line-height: 32px;
        cursor: pointer;
      }
    }
  }
  .el-input{
      width: 200px !important;
  }
}
</style>
